import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    activeSlide: '',
    randomComponentCount: 6,
    animateBackground: false,
    currentBackground: null,
    nextBackground: null,
    interactiveData: {
      'hasNavigation': false,
      'characterPath': '',
      'currentScore': 0,
      'maxScore': 0,
      'scoreKeys': [],
      'themes': {
        'cleanSmart': {
          'mainColor': '#cb0457',
          'logoPath': 'images/update/lead-inter-asset-cleanLogo.png',
          'backgroundPath': 'images/lead-inter-asset-cleanBg.png',
          'characterPath': 'images/gifs/LeadTed.gif'
        },
        'eatSmart': {
          'mainColor': '#2c86ae',
          'logoPath': 'images/update/lead-inter-asset-eatLogo.png',
          'backgroundPath': 'images/lead-inter-asset-eatBg.png',
          'characterPath': 'images/gifs/MaddieBlue.gif'
        },
        'liveSmart': {
          'mainColor': '#48982a',
          'logoPath': 'images/update/lead-inter-asset-liveLogo.png',
          'backgroundPath': 'images/lead-inter-asset-liveBg.png',
          'characterPath': 'images/gifs/RedJack.gif'
        },
        'leadSmart': {
          'mainColor': '#f39c12',
          'logoPath': '',
          'backgroundPath': 'images/lead-inter-asset-leadBg.png',
          'characterPath': [
            'images/gifs/LeadTedThumbs.gif'// ,
            // 'images/lead-inter-asset-thumbsup.png',
            // 'images/lead-inter-asset-thumbsup.png'
          ]
        }
      }
    },
    componentData: {
      'title_slide': {
        'id': 'title_slide',
        'componentName': 'title-slide',
        'class': ['hidden'],
        'data': {
          'category': 'leadSmart',
          'title': 'leadSmart',
          'description': [],
          'imagePath': [
            'images/gifs/MaddieBlue.gif',
            'images/gifs/LeadTed.gif',
            'images/gifs/RedJack.gif'
          ],
          'imagePath2': [
            'images/lead-inter-asset-eatBox.png',
            'images/lead-inter-asset-cleanBox.png',
            'images/lead-inter-asset-liveBox.png'
          ],
          'actions': {
            'action_01': {
              'id': 'action_01',
              'label': 'Start the Quiz',
              'iconPath': ['images/next-arrow.png'],
              'description': 'How Leadsmart are you?'
            }
          }
        }
      },
      'result_slide': {
        'id': 'result_slide',
        'componentName': 'result-board',
        'class': ['hidden'],
        'data': {
          'category': 'leadSmart',
          'currentScore': 0,
          'maxScore': 10,
          'ranks': {
            'rank_1st': {
              'label': 'Great Job!',
              'targetScore': 100,
              'message': 'Great job, you know lots  about being LeadSmart!',
              'imagePath': 'images/lead-inter-asset-star3.png'
            },
            'rank_2nd': {
              'label': 'Well done!',
              'targetScore': 50,
              'message': 'Well done, you know some ways to be LeadSmart!',
              'imagePath': 'images/lead-inter-asset-star2.png'
            },
            'rank_3rd': {
              'label': 'Good try!',
              'targetScore': 0,
              'message': 'Good try, learn more about being LeadSmart and try the quiz again!',
              'imagePath': 'images/lead-inter-asset-star1.png'
            }
          }
        }
      },
      'quiz_eatSmart_1': {
        'id': 'quiz_eatSmart_1',
        'componentName': 'quiz-multiple',
        'completed': false,
        'class': ['hidden'],
        'data': {
          'category': 'eatSmart',
          'title': 'Eat Smart',
          'description': 'When eating, it\'s best to sit on the ground or floor.',
          'answerDescription': 'You should avoid sitting on the ground or floor, sitting at a table is best. If you have to sit on the ground put a clean blanket or towel down first to keep lead dust out of the food and off hands.',
          'imagePath': 'images/lead-inter-asset-boy-1.png',
          'currentScore': 0,
          'totalScore': 1,
          'responses': [
            {
              'text': 'True',
              'isCorrect': false,
              'isSelected': false
            },
            {
              'text': 'False',
              'isCorrect': true,
              'isSelected': false
            }
          ]
        }
      },
      'quiz_eatSmart_2': {
        'id': 'quiz_eatSmart_2',
        'componentName': 'quiz-multiple',
        'completed': false,
        'class': ['hidden'],
        'data': {
          'category': 'eatSmart',
          'title': 'Eat Smart',
          'description': 'Breakfast is the most important meal of the day and will stop you from absorbing more lead.',
          'answerDescription': 'A child who doesn\'t eat breakfast can absorb up to seven times more lead than a child who does eat breakfast.',
          'imagePath': 'images/lead-inter-asset-boy-1.png',
          'currentScore': 0,
          'totalScore': 1,
          'responses': [
            {
              'text': 'True',
              'isCorrect': true,
              'isSelected': false
            },
            {
              'text': 'False',
              'isCorrect': false,
              'isSelected': false
            }
          ]
        }
      },
      'quiz_eatSmart_3': {
        'id': 'quiz_eatSmart_3',
        'componentName': 'quiz-multiple',
        'completed': false,
        'class': ['hidden'],
        'data': {
          'category': 'eatSmart',
          'title': 'Pop Quiz 2',
          'description': 'If rainwater from tanks looks and smells clean it\'s healthy for you to drink.',
          'answerDescription': 'It\'s important to drink lots of tap water. Be careful not to drink rainwater from water tanks, it can look and smells like clean water but may still contain lead.',
          'imagePath': 'images/lead-inter-asset-boy-1.png',
          'currentScore': 0,
          'totalScore': 1,
          'responses': [
            {
              'text': 'True',
              'isCorrect': false,
              'isSelected': false
            },
            {
              'text': 'False',
              'isCorrect': true,
              'isSelected': false
            }
          ]
        }
      },
      'quiz_eatSmart_4': {
        'id': 'quiz_eatSmart_4',
        'componentName': 'quiz-multiple',
        'completed': false,
        'class': ['hidden'],
        'data': {
          'category': 'eatSmart',
          'title': 'Pop Quiz 2',
          'description': 'Don\'t eat too many snacks, it’s best to eat just breakfast, lunch and dinner.',
          'answerDescription': 'It\'s important to eat regular, small healthy snacks to keep your tummy full. A full tummy will absorb less lead',
          'imagePath': 'images/lead-inter-asset-boy-1.png',
          'currentScore': 0,
          'totalScore': 1,
          'responses': [
            {
              'text': 'True',
              'isCorrect': false,
              'isSelected': false
            },
            {
              'text': 'False',
              'isCorrect': true,
              'isSelected': false
            }
          ]
        }
      },
      'quiz_cleanSmart_1': {
        'id': 'quiz_cleanSmart_1',
        'componentName': 'quiz-multiple',
        'completed': false,
        'class': ['hidden'],
        'data': {
          'category': 'cleanSmart',
          'title': 'Clean Smart',
          'description': 'It\'s important to sweep and dry dust inside your house to prevent lead dust from spreading.',
          'answerDescription': 'Sweeping or dry dusting can disturb lead dust and make it swirl around and land on other surfaces. When cleaning it\'s best to use a wet wipe and mop all hard surfaces such as floors and furniture.',
          'imagePath': 'images/lead-inter-asset-boy-1.png',
          'currentScore': 0,
          'totalScore': 1,
          'responses': [
            {
              'text': 'True',
              'isCorrect': false,
              'isSelected': false
            },
            {
              'text': 'False',
              'isCorrect': true,
              'isSelected': false
            }
          ]
        }
      },
      'quiz_cleanSmart_2': {
        'id': 'quiz_cleanSmart_2',
        'componentName': 'quiz-multiple',
        'completed': false,
        'class': ['hidden'],
        'data': {
          'category': 'cleanSmart',
          'title': 'Clean Smart',
          'description': 'You should wash your pet regularly and brush it outdoors.',
          'answerDescription': 'Pets love exploring and unfortunately can get dirt, dust and soil on their fur. It’s important to wash pets regularly, brush them outside and avoid letting them sleep on your bed.',
          'imagePath': 'images/lead-inter-asset-boy-1.png',
          'currentScore': 0,
          'totalScore': 1,
          'responses': [
            {
              'text': 'True',
              'isCorrect': true,
              'isSelected': false
            },
            {
              'text': 'False',
              'isCorrect': false,
              'isSelected': false
            }
          ]
        }
      },
      'quiz_cleanSmart_3': {
        'id': 'quiz_cleanSmart_3',
        'componentName': 'quiz-multiple',
        'completed': false,
        'class': ['hidden'],
        'data': {
          'category': 'cleanSmart',
          'title': 'Clean Smart',
          'description': 'You need to wash your hands ONLY if you have been playing outside.',
          'answerDescription': 'Washing your hands is the most effective way of keeping lead out of your body. You should wash your hands regularly no matter if you spend time indoors or outdoors, especially before eating. If you touch something with lead on it it can go on your hands and increase the risk of you swallowing lead.',
          'imagePath': 'images/lead-inter-asset-boy-1.png',
          'currentScore': 0,
          'totalScore': 1,
          'responses': [
            {
              'text': 'True',
              'isCorrect': false,
              'isSelected': false
            },
            {
              'text': 'False',
              'isCorrect': true,
              'isSelected': false
            }
          ]
        }
      },
      'quiz_cleanSmart_4': {
        'id': 'quiz_cleanSmart_4',
        'componentName': 'quiz-multiple',
        'completed': false,
        'class': ['hidden'],
        'data': {
          'category': 'cleanSmart',
          'title': 'Clean Smart',
          'description': 'Leave shoes outside and use a doormat before entering your house.',
          'answerDescription': 'Your shoes may have soil, dirt or dust on them which all could contain lead. It’s best to take your shoes off and leave them outside to reduce the risk of spreading lead inside your home.',
          'imagePath': 'images/lead-inter-asset-boy-1.png',
          'currentScore': 0,
          'totalScore': 1,
          'responses': [
            {
              'text': 'True',
              'isCorrect': true,
              'isSelected': false
            },
            {
              'text': 'False',
              'isCorrect': false,
              'isSelected': false
            }
          ]
        }
      },
      'quiz_liveSmart_1': {
        'id': 'quiz_liveSmart_1',
        'componentName': 'quiz-multiple',
        'completed': false,
        'class': ['hidden'],
        'data': {
          'category': 'liveSmart',
          'title': 'Clean Smart',
          'description': 'It\'s important to be LeadSmart while living in Broken Hill',
          'answerDescription': 'Being LeadSmart can reduce your exposure to lead and prevent lead harm.',
          'imagePath': 'images/lead-inter-asset-boy-1.png',
          'currentScore': 0,
          'totalScore': 1,
          'responses': [
            {
              'text': 'True',
              'isCorrect': true,
              'isSelected': false
            },
            {
              'text': 'False',
              'isCorrect': false,
              'isSelected': false
            }
          ]
        }
      },
      'quiz_liveSmart_2': {
        'id': 'quiz_liveSmart_2',
        'componentName': 'quiz-multiple',
        'completed': false,
        'class': ['hidden'],
        'data': {
          'category': 'liveSmart',
          'title': 'Clean Smart',
          'description': 'On dry and windy days you should open your windows and doors to air out your house.',
          'answerDescription': 'Because of Broken Hill\'s dry climate, wind can disturb and pick up lead. You should close your windows and doors on dry and windy days to prevent lead from getting inside your home.',
          'imagePath': 'images/lead-inter-asset-boy-1.png',
          'currentScore': 0,
          'totalScore': 1,
          'responses': [
            {
              'text': 'True',
              'isCorrect': false,
              'isSelected': false
            },
            {
              'text': 'False',
              'isCorrect': true,
              'isSelected': false
            }
          ]
        }
      },
      'quiz_liveSmart_3': {
        'id': 'quiz_liveSmart_3',
        'componentName': 'quiz-multiple',
        'completed': false,
        'class': ['hidden'],
        'data': {
          'category': 'liveSmart',
          'title': 'Clean Smart',
          'description': 'If you are playing outside, avoid playing in bare dirt, dust and soil.',
          'answerDescription': 'Bare dirt, dust and soil may contain lead. Its best to play on grass or other covered surfaces where possible.',
          'imagePath': 'images/lead-inter-asset-boy-1.png',
          'currentScore': 0,
          'totalScore': 1,
          'responses': [
            {
              'text': 'True',
              'isCorrect': true,
              'isSelected': false
            },
            {
              'text': 'False',
              'isCorrect': false,
              'isSelected': false
            }
          ]
        }
      },
      'quiz_liveSmart_4': {
        'id': 'quiz_liveSmart_4',
        'componentName': 'quiz-multiple',
        'completed': false,
        'class': ['hidden'],
        'data': {
          'category': 'liveSmart',
          'title': 'Live Smart',
          'description': 'If you see old chipped or flaking paint you should tell an adult straight away.',
          'answerDescription': 'If you see chipped or flaking paint, it’s best to assume that it’s old paint that may contain lead. Tell an adult straight away and avoid touching it.',
          'imagePath': 'images/lead-inter-asset-boy-1.png',
          'currentScore': 0,
          'totalScore': 1,
          'responses': [
            {
              'text': 'True',
              'isCorrect': true,
              'isSelected': false
            },
            {
              'text': 'False',
              'isCorrect': false,
              'isSelected': false
            }
          ]
        }
      }
    },
    componentIdOrder: [
      'title_slide',
      'result_slide'
    ]
  },
  getters: {
    getData (state) {
      return function (keyword) {
        return state.componentData[keyword]
      }
    },
    getInfo (state) {
      return function () {
        return state.interactiveData
      }
    },
    getThemes (state) {
      return function (category) {
        return state.interactiveData.themes[category]
      }
    }
  },
  mutations: {
    setValue (state, {id, key, value}) {
      _.set(state.componentData[id], key, value)
    },
    nextSlide (state) {
      let currentSlideIndex = state.componentIdOrder.indexOf(state.activeSlide)
      let nextSlideIndex = currentSlideIndex + 1

      if (nextSlideIndex < state.componentIdOrder.length) {
        changeBackground(state, nextSlideIndex)
        state.componentData[state.activeSlide].class = 'slideOutLeft change'
        state.activeSlide = state.componentIdOrder[nextSlideIndex]
        state.componentData[state.activeSlide].class = 'slideInRight change'
        setTimeout(() => {
          state.componentData[state.activeSlide].class = 'current'
          state.componentData[state.componentIdOrder[currentSlideIndex]].class = 'hidden'
        }, 500)
      }
    },
    previousSlide (state) {
      let currentSlideIndex = state.componentIdOrder.indexOf(state.activeSlide)
      let nextSlideIndex = currentSlideIndex - 1

      if (nextSlideIndex >= 0) {
        changeBackground(state, nextSlideIndex)
        state.componentData[state.activeSlide].class = 'slideOutRight change'
        state.activeSlide = state.componentIdOrder[nextSlideIndex]
        state.componentData[state.activeSlide].class = 'slideInLeft change'

        setTimeout(() => {
          state.componentData[state.activeSlide].class = 'current'
          state.componentData[state.componentIdOrder[currentSlideIndex]].class = 'hidden'
        }, 500)
      }
    },
    goToSlide (state, slideIndex) {
      let currentSlideIndex = state.componentIdOrder.indexOf(state.activeSlide)
      let inAnimation, outAnimation

      if (currentSlideIndex > slideIndex) {
        inAnimation = 'slideInLeft change'
        outAnimation = 'slideOutRight change'
      } else {
        inAnimation = 'slideInRight change'
        outAnimation = 'slideOutLeft change'
      }

      if (slideIndex >= 0) {
        if (state.componentData[state.activeSlide] !== undefined) {
          state.componentData[state.activeSlide].class = outAnimation
        }
        state.activeSlide = state.componentIdOrder[slideIndex]
        state.componentData[state.activeSlide].class = inAnimation
        changeBackground(state, slideIndex)
        setTimeout(() => {
          state.componentData[state.activeSlide].class = 'current'
          if (currentSlideIndex >= 0) {
            state.componentData[state.componentIdOrder[currentSlideIndex]].class = 'hidden'
          }
        }, 500)
      }
    },
    randomizeComponent (state, keywords) {
      let matchingObjects = []
      let randomComponent = []
      let maxComponent
      for (let compObj in state.componentData) {
        if (typeof keywords === 'string' || keywords instanceof String) {
          let categ = state.componentData[compObj].data.category
          if (categ !== undefined && categ.includes(keywords) &&
            !state.componentIdOrder.includes(compObj.toString())) {
            matchingObjects.push(compObj.toString())
          }
        } else if (!state.componentIdOrder.includes(compObj.toString())) { // If no keywords is passed
          matchingObjects.push(compObj.toString())
        }
      }
      if (matchingObjects.length > state.randomComponentCount) {
        maxComponent = state.randomComponentCount
      } else {
        maxComponent = matchingObjects.length
      }
      for (let i = 0; i < maxComponent; i++) {
        let rand = matchingObjects[Math.floor(Math.random() * matchingObjects.length)]
        while (randomComponent.includes(rand)) {
          if (randomComponent.length <= i) {
            rand = matchingObjects[Math.floor(Math.random() * matchingObjects.length)]
          }
        }
        randomComponent.push(rand)
      }
      /** LeasSmart S2 specific component sorting */
      // state.componentIdOrder.splice(0, 0, ...randomComponent)

      /** LeasSmart Quiz specific component sorting */
      state.componentIdOrder.splice(1, 0, ...randomComponent)

      // state.componentIdOrder = state.componentIdOrder.concat(randomComponent)
    },
    setScoreData (state) {
      let maxScore = 0
      let scoreKeys = []
      for (let index = 0; index < state.componentIdOrder.length; index++) {
        let key = state.componentIdOrder[index]
        let score = state.componentData[key].data.totalScore
        if (score !== undefined) {
          maxScore = maxScore + score
          scoreKeys.push(key)
        }
      }
      state.interactiveData.scoreKeys = scoreKeys
      state.interactiveData.maxScore = maxScore
    }
  }
})

const changeBackground = (state, nextSlideIndex) => {
  let nextSlideComponent = state.componentIdOrder[nextSlideIndex]
  let nextThemeCategory = state.componentData[nextSlideComponent].data.category

  state.nextBackground = state.interactiveData.themes[nextThemeCategory].backgroundPath
  state.animateBackground = true
  setTimeout(() => {
    state.animateBackground = false
    state.currentBackground = state.nextBackground
  }, 500)
}



// WEBPACK FOOTER //
// ./src/store.js